import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Printer, EnvelopeSimple, X } from "@phosphor-icons/react";

const POLL_MS = 30 * 1000;
const SHOW_MS = 10 * 1000;

function Note({ n, onClose, onOpen }) {
  const isScan = n.kind === "scan";
  const Icon = isScan ? Printer : EnvelopeSimple;
  return (
    <div className="pointer-events-auto w-80 rounded-md border border-slate-200 bg-white shadow-lg p-3 flex gap-2 animate-in slide-in-from-right-5 fade-in"
      data-testid={`mailbox-note-${n.id}`}>
      <Icon size={18} className={isScan ? "text-indigo-600 mt-0.5" : "text-teal-700 mt-0.5"} />
      <button type="button" className="flex-1 text-left min-w-0" onClick={onOpen} data-testid={`mailbox-note-open-${n.id}`}>
        <div className="text-xs font-semibold text-slate-900">{isScan ? "Neuer Scan eingegangen" : `Neue Mail an ${(n.mailbox || "").slice(7)}`}</div>
        <div className="text-xs text-slate-700 truncate">{n.subject || "(ohne Betreff)"}</div>
        {!isScan && n.from_name && <div className="text-[11px] text-slate-500 truncate">von {n.from_name}</div>}
      </button>
      <button type="button" onClick={onClose} className="text-slate-400 hover:text-slate-700 self-start" aria-label="Schließen" data-testid={`mailbox-note-close-${n.id}`}><X size={14} /></button>
    </div>
  );
}

// Pollt das Postfach: liefert den Menü-Zähler und zeigt Hinweise oben rechts bei neuen Scans / Team-Postfach-Mails.
export default function MailboxWatcher({ onCount }) {
  const navigate = useNavigate();
  const since = useRef(null);
  const [notes, setNotes] = useState([]);
  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const { data } = await api.get("/mailbox/inbox-summary", { params: { since: since.current || undefined } });
        if (!alive) return;
        onCount(data.open);
        if (since.current && data.new_items.length) {
          setNotes((x) => [...data.new_items.filter((n) => !x.some((y) => y.id === n.id)), ...x].slice(0, 4));
          data.new_items.forEach((n) => setTimeout(() => setNotes((x) => x.filter((y) => y.id !== n.id)), SHOW_MS));
        }
        since.current = data.now;
      } catch { /* Postfach nicht verfügbar */ }
    };
    tick();
    const iv = setInterval(tick, POLL_MS);
    window.addEventListener("domivus:postfach-changed", tick);
    return () => { alive = false; clearInterval(iv); window.removeEventListener("domivus:postfach-changed", tick); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const close = (id) => setNotes((x) => x.filter((y) => y.id !== id));
  return (
    <div className="fixed top-16 right-4 z-[60] flex flex-col gap-2 pointer-events-none" data-testid="mailbox-notes">
      {notes.map((n) => <Note key={n.id} n={n} onClose={() => close(n.id)} onOpen={() => { close(n.id); navigate("/postfach"); }} />)}
    </div>
  );
}
